//===============================================================================================================
// #1 - Base Imports
//===============================================================================================================
import React from "react";

//===============================================================================================================
// #2 - Import * React Router Dom
//===============================================================================================================
import { useLocation, useHistory } from "react-router-dom";

//===============================================================================================================
// #3 - Import * Font Awesome Icons
//===============================================================================================================
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

import { SvgIcon } from './styles';

export const BreakMenu = ({ title }) => {

    return (
        <>
            {title && (

                <div className="break-menu">
                    <h1 className="title">{title ? title : "..."}</h1>
                </div>
            )}
        </>
    )
}

export const Menu = ({ title, children }) => {

    return (
        <>
            {children && (
                <div className="wrap-user-menu-with-description">
                    <BreakMenu title={title} />
                    <nav className="user-menu-with-description">
                        <ul>
                            {children}
                        </ul>
                    </nav>
                </div>
            )}
        </>
    )
}

export const MenuItem = ({ link, icon, svgIconColor, title, subtitle, withArrowIcon, onClick, children, className, paramReadOnly }) => {

    const location = useLocation();
    const history = useHistory();

    const redirect = (link) => {
        if (paramReadOnly) {
            history.push({ pathname: link, search: `${location.search}&${paramReadOnly}` });
        } else if (link.indexOf("#!") === -1) {
            history.push({ pathname: link, search: `${location.search}` });
        }
    }

    return (
        <li className={className} onClick={() => onClick ? onClick(link) : redirect(link)}>
            <div className="menu-item-columns">
                <div className="menu-item-column">
                    <a href={"#!"}>
                        {icon && (
                            <div className="icon">
                                <SvgIcon svgIconColor={svgIconColor ? svgIconColor : 'red'}>
                                    {icon}
                                </SvgIcon>
                            </div>
                        )}

                        <div className="menu-description">
                            <div className="title">
                                {title}
                            </div>

                            {subtitle && (
                                <div className="subtitle">
                                    {subtitle}
                                </div>
                            )}
                        </div>
                    </a>
                </div>
                <div className="menu-item-column">
                    {children}
                    {withArrowIcon && (
                        <div className="icon">
                            <Icon icon={faChevronRight} />
                        </div>
                    )}
                </div>
            </div>
        </li>
    )
}